import React from 'react';

import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

const PanelHeader = (props) => {
    let oProductos = null;
    let productoValue = null;
    let productos = JSON.parse(JSON.stringify(props.permiso.listaProductos));
    if (productos) {
        productos.unshift({ Id: 0, Descripcion: "Seleccione un producto..." });
        oProductos = productos.map(function (producto) {
            if (producto.Id == props.permiso.productoId) {
                productoValue = producto.Id;
            }

            if (producto.Id >= 0)
                return <GenericOption id={producto.Id} description={producto.Descripcion} key={"ProdOp_" + producto.Id} />;
        });
    }

    let oCategorias = null;
    let categoriaValue = null;
    let categorias = JSON.parse(JSON.stringify(props.permiso.listaCategorias));
    if (categorias) {
        categorias = categorias.filter(x => x.ProductoId == props.permiso.productoId);
        categorias.unshift({ Id: 0, Descripcion: "Seleccione una categoría..." });

        oCategorias = categorias.map(function (categoria) {
            if (categoria.Id == props.permiso.categoriaId) {
                categoriaValue = categoria.Id;
            }
            return <GenericOption id={categoria.Id} description={categoria.Descripcion} key={"CatOp_" + categoria.Id} />;
        });
    }

    let oProgramas = null;
    let programaValue = null;
    let programas = JSON.parse(JSON.stringify(props.permiso.listaProgramas));
    if (programas) {
        programas = programas.filter(x => x.CategoriaId == props.permiso.categoriaId);
        programas.unshift({ Id: 0, Descripcion: "Seleccione un programa..." });

        oProgramas = programas.map(function (programa) {
            if (programa.Id == props.permiso.programaId) {
                programaValue = programa.Id;
            }
            return <GenericOption id={programa.Id} description={programa.Descripcion} key={"ProgOp_" + programa.Id} />;
        });
    }

    return (
        <div className="row bottom-separator-xxs">
            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-11">
                        <h3>...permisos en...</h3>
                    </div>
                    {props.permisos.length > 1
                        ? <div className="col-xs-1 text-right">
                            <div onClick={() => props.deletePermiso(props.permiso.id)}>
                                <span className="ti-close clickable"></span>
                            </div>
                        </div> : null}
                </div>
            </div>
            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-4">
                        <GenericSelect id="selProducts"
                            options={oProductos}
                            value={productoValue}
                            onChange={(e) => props.selectProducto(props.permiso.id, e.target.value)}
                            className={"form-control default-select"} />
                    </div>
                    <div className="col-xs-4">
                        <GenericSelect id="selCategoria" options={oCategorias}
                            value={categoriaValue}
                            onChange={(e) => props.selectCategoria(props.permiso.id, e.target.value)}
                            className={"form-control default-select"} />
                    </div>
                    <div className="col-xs-4">
                        <GenericSelect id="selProgramas" options={oProgramas}
                            value={programaValue}
                            onChange={(e) => props.selectPrograma(props.permiso.id, e.target.value)}
                            className={"form-control default-select"} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PanelHeader;